import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CachePreferences } from 'src/app/features/cache/cache-preferences';

export enum BrowserPreference {
  COOKIE_ACCEPTED = 'CA_UX120DK3',
  TERMS_ACCEPTEDS_ON_CREATE_ACCOUNT = 'NA_OG321LG8',
  LAST_LOGGED_USER = 'LL_NA194LI4',
  LAST_ATHLETE_CHAMPIONSHIP_SEASON = 'LAS_BPR930SD'
}


@Injectable({
  providedIn: 'root'
})
export class BrowserPreferencesService {
  private cache: CachePreferences = new CachePreferences();
  private _started = new BehaviorSubject(false);
  public started$ = this._started.asObservable();

  private tables: {
    id: string;
    createdAt: string;
  }[];

  constructor() {
    this.init();
  }

  private async started() {
    return new Promise((resolve) => {
      this.started$
        .pipe(filter(s => s == true))
        .subscribe(() => resolve(true));
    });
  }

  async init() {
    let tables = await this.cache.listTables();
    while (!tables || tables.length == 0) {
      tables = await this.cache.listTables();
    }
    this.tables = tables;
    this._started.next(true);
  }

  async get<R = any>(key: BrowserPreference): Promise<R> {
    await this.started();
    const preferences = await this.cache.get(key as any);
    return preferences;
  }

  async set<K = BrowserPreference, R = any>(key: K | string, value: object): Promise<R> {
    return this.cache.set(key as string, value);
  }


}
